import { Map as olMap, View, Feature } from 'ol';
import { Tile, Vector } from 'ol/layer';
import { Point } from 'ol/geom';
import { XYZ, Vector as VectorSource } from 'ol/source';
import { Style, Icon } from 'ol/style';
import { boundingExtent, buffer, getCenter } from 'ol/extent';
import { fromLonLat } from 'ol/proj';

const defaultPinColor = 'pin-black';
const defaultIconPath = `${window.GLOBALS.webroot}/customers/zslinth/frontend/static/graphics/osm-${defaultPinColor}.svg`;

const pageIds = [
    { color: 'red', id: 'agendaPage_get' },
    { color: 'black', id: 'magazinPage_get' },
    { color: 'green', id: 'kulturplatzPage_get' },
];

// we use EPSG:4326 / WGS84 projection but osm.ch map tiles uses EPSG:3857
const projection = 'EPSG:3857';

// coords should be given in longitude and latitude in an array
const defaultCoords = {
    switzerland: fromLonLat([8.224103, 46.822427]),
    thurgau: fromLonLat([9.08537, 47.535911]),
};

const boundingExtentCoords = [];

export function initMap() {
    const container = document.getElementById('ol-map');
    if (!container) {
        return;
    }

    if (window.mapCoords && window.mapCoords.length > 0) {
        drawMapWithLocators(container, window.mapCoords);
    }
}

export function drawMapWithLocators(container = null, coords = []) {
    if (!container) {
        return;
    }

    // the map view will initially shows thurgau
    const view = new View({
        projection: projection,
        // zoom: 6.8, // zoom for switzerland
        zoom: 15, // zoom for thurgau
        center: defaultCoords.thurgau,
    });

    // this is where we create the OpenLayers map
    const map = new olMap({
        target: container,
        projection: projection,
        layers: [
            // adding a background tiled layer
            new Tile({
                id: 'background-layer',
                source: new XYZ({
                    url: `https://tile.osm.ch/osm-swiss-style/{z}/{x}/{y}.png`,
                    attributions: [
                        'Data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors <a href="https://opendatacommons.org/licenses/odbl/">ODbL</a>',
                        ' | Map by <a href="https://sosm.ch/">SOSM</a>',
                        ` | <a id="problem-attribution" href="http://www.openstreetmap.org/fixthemap?lat=0&lon=0&zoom=15">Report a problem</a>`,
                    ],
                    attributionsCollapsible: false,
                }),
            }),
        ],
        view: view,
    });

    coords.forEach((coord) => drawMarkerOnMap(map, coord));

    if (boundingExtentCoords.length === 0) {
        return;
    }

    if (coords.length > 0) {
        // resize the view to fit all the markers with a buffer in it
        // this will overwrite de zoom set in the view
        const extent = buffer(boundingExtent(boundingExtentCoords), 5000); // good amount for EPSG:4326: 0.1, for EPSG:3857: 5000
        view.setCenter(getCenter(extent));
        view.fit(extent);
    }
}

export function drawMarkerOnMap(map = {}, coord = []) {
    if (coord.length === 0) {
        return;
    }

    boundingExtentCoords.push(fromLonLat([coord.lng, coord.lat]));

    const vectorSource = new VectorSource({
        features: [
            new Feature({
                geometry: new Point(fromLonLat([coord.lng, coord.lat])),
            }),
        ],
    });

    map.addLayer(
        new Vector({
            title: 'Company Location',
            source: vectorSource,
            style: new Style({
                image: new Icon({
                    src: generateIconLink(),
                    anchor: [0.5, 1], // 0.5: middle on horizontal axis, 1: bottom of vertical axis.
                    //   scale: 0.1,
                }),
            }),
        }),
    );
}

export function generateIconLink() {
    let iconPath = defaultIconPath;
    const bodyEl = document.querySelector('body');
    const bodyHasId = bodyEl.hasAttribute('id');
    const bodyId = bodyHasId ? bodyEl.getAttribute('id') : null;

    let foundObj = pageIds.find((e) => e.id === bodyId);

    if (foundObj) {
        iconPath = iconPath.replace(defaultPinColor, `pin-${foundObj.color}`);
    }

    return iconPath;
}
